import { Button, Loading, Modal, Typography } from "@/components/atoms";
import { getErrorMessages } from "@/helpers/reduxHelpers";
import { useDeleteLocationBasedFixedPricingMutation } from "@/redux/apis/config/trip/tripCost";
import { FixedPricingLocation, PricingProfile } from "@/redux/slices/trip/types";
import { addToast } from "@/utils";

interface DeleteZonePricingModalProps {
  open: boolean;
  onClose: () => void;
  selectedZone?: FixedPricingLocation;
  pricingProfile?: PricingProfile;
}

export const DeleteZonePricingModal = ({ open, onClose, selectedZone, pricingProfile }: DeleteZonePricingModalProps) => {
  const [deleteZonePricing, { isLoading }] = useDeleteLocationBasedFixedPricingMutation();

  const handleClose = () => {
    if (!isLoading) onClose();
  };

  const handleConfirmDelete = () => {
    if (pricingProfile && selectedZone) {
      deleteZonePricing({ profileId: pricingProfile.id, locationId: selectedZone.id })
        .unwrap()
        .then(() => {
          addToast("success", "Successfully Deleted Zone Pricing");
          handleClose();
        })
        .catch((e) => getErrorMessages(e).forEach((m) => addToast("danger", m)));
    } else handleClose();
  };

  return (
    <Modal className="w-[85vw] md:w-[400px] lg:w-[400px]" open={open} onClose={handleClose}>
      <div className="relative flex flex-col">
        {isLoading && <Loading />}
        <Typography variant="title">Delete Zone Pricing</Typography>
        <Typography variant="paragraph" className="mt-2 text-neutral-dark-gray">
          By clicking &quot;Delete,&quot; all the custom pricing for this trip will be deleted. Please note that this action is
          irreversible.
        </Typography>
        <div className="mt-8 flex w-full flex-row gap-3">
          <Button variant="secondary" size="lg" onClick={handleClose} className="flex-1">
            Cancel
          </Button>
          <Button variant="primary" size="lg" onClick={handleConfirmDelete} className="flex-1 border-none bg-danger hover:bg-danger-dark">
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
};
